import React from 'react'
import { colors } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { bool, func, number, objectOf, oneOfType, string } from 'prop-types'
import flame from './images/flame.svg'
import greyFlame from './images/greyFlame.svg'

const blockCss = css`
  background-color: ${colors.blue03};
  border-radius: 100px;
  padding: 5px 15px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  img {
    width: 20px;
  }
  &:focus {
    outline: 2px solid ${colors.blue60};
  }
`

export default function StreakBlock({ streakCount, simple, color = colors.gray90, style, onClick, isCurrent }) {
  const [t] = useTranslation()
  const flexDirection = { flexDirection: simple ? 'row-reverse' : 'row' }
  const flameToUse = isCurrent ? flame : greyFlame
  const handleClick = onClick
    ? () => {
        trackEvent({
          event_name: 'Streaks.BUTTON:CLICK',
        })
        onClick()
      }
    : undefined

  return (
    <button
      data-testid="streak-block"
      type="button"
      css={blockCss}
      onClick={handleClick}
      style={{ ...style, ...flexDirection }}
    >
      <span
        aria-label={t('progress.weeks-count', { weekCount: streakCount })}
        style={{ color, fontWeight: 700, verticalAlign: 'middle', marginInlineStart: '5px' }}
      >
        {streakCount}
      </span>
      <img src={flameToUse} alt="" />
    </button>
  )
}

StreakBlock.propTypes = {
  streakCount: number,
  simple: bool,
  color: string,
  style: objectOf(oneOfType([string, number])),
  onClick: func,
  isCurrent: bool,
}
